import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import axios from "axios";
import FileManager from "../../utils/FileManager";
import {
  getWomanDictionary,
  getManDictionary,
  getFamilyCon,
} from "../../handlers/dictionaryHandler.js";

const GetOneProfileExtra = ({
  otherId,
  showManagerOnly = false,
  onProfileLoaded,
}) => {
  const [agepartner, setAgepartner] = useState("");
  const [tallpartner, setTallpartner] = useState("");
  const [distancepartner, setDistancepartner] = useState("");
  const [religouspartner, setReligouspartner] = useState("");
  const [statuspartner, setStatuspartner] = useState("");
  const [educationpartner, setEducationpartner] = useState("");
  const [partnerShape, setPartnerShape] = useState("");

  const [image1aBlobURL, setImage1aBlobURL] = useState("");
  const [image2aBlobURL, setImage2aBlobURL] = useState("");
  const [image3aBlobURL, setImage3aBlobURL] = useState("");
  const [image4aBlobURL, setImage4aBlobURL] = useState("");
  const [image5aBlobURL, setImage5aBlobURL] = useState("");

  const [facebook1, setFacebook1] = useState("");
  const [instegram1, setInstegram1] = useState("");
  const [recordingBlobURL1a, setRecordingBlobURL1a] = useState("");
  const [myRecord1a, setMyRecord1a] = useState("");
  const [record1a, setRecord1a] = useState("");
  const [dateRecord1a, setDateRecord1a] = useState("");
  const [isRecord1aPlaying, setIsRecord1aPlaying] = useState(false);

  const [cameraAreaVisible, setCameraAreaVisible] = useState(false);
  const [faceAreaVisible, setFaceAreaVisible] = useState(false);
  const [instegramAreaVisible, setInstegramAreaVisible] = useState(false);
  const [recordAreaVisible, setRecordAreaVisible] = useState(false);

  const [editedGender, setEditedGender] = useState("");
  const [cellular, setCellular] = useState("");
  const [id1, setId1] = useState("");
  const [vipDetails, setVipDetails] = useState("");
  const [isVip, setIsVip] = useState("");
  const [userType, setUserType] = useState("");
  const [helperName, setHelperName] = useState("");
  const [helperCellular, setHelperCellular] = useState("");
  const [helperEmail, setHelperEmail] = useState("");
  const [helperConnection, setHelperConnection] = useState("");
  const [helperAllowSee, setHelperAllowSee] = useState("");
  const [isActive, setIsActive] = useState("");
  const [m1details, setM1details] = useState("");
  const [m2details, setM2details] = useState("");
  const [m3details, setM3details] = useState("");
  const [m4details, setM4details] = useState("");
  const [m5details, setM5details] = useState("");

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const closeAllMediaAreas = () => {
    setCameraAreaVisible(false);
    setFaceAreaVisible(false);
    setInstegramAreaVisible(false);
    setRecordAreaVisible(false);
  };

  const recordBtnClick = () => {
    setCameraAreaVisible(false);
    setFaceAreaVisible(false);
    setInstegramAreaVisible(false);
    setRecordAreaVisible(!recordAreaVisible);
  };

  const instegramBtnClick = () => {
    setFaceAreaVisible(false);
    setCameraAreaVisible(false);
    setInstegramAreaVisible(!instegramAreaVisible);
    setRecordAreaVisible(false);
  };

  const facebookBtnClick = () => {
    setFaceAreaVisible(!faceAreaVisible);
    setCameraAreaVisible(false);
    setInstegramAreaVisible(false);
    setRecordAreaVisible(false);
  };

  const cameraBtnClick = () => {
    setCameraAreaVisible(!cameraAreaVisible);
    setFaceAreaVisible(false);
    setInstegramAreaVisible(false);
    setRecordAreaVisible(false);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        closeAllMediaAreas();

        const response = await axios.post(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/getDetailsByCell",
          { cell: otherId },
          config,
        );

        const userData = response.data;

        if (userData[0].length > 0) {
          const row = userData[0][0];

          if (onProfileLoaded) {
            onProfileLoaded(row);
          }

          setAgepartner(row.agepartner || "");
          setTallpartner(row.tallpartner || "");
          setDistancepartner(row.distancepartner || "");
          setReligouspartner(row.religouspartner || "");
          setStatuspartner(row.statuspartner || "");
          setEducationpartner(row.educationpartner || "");
          setPartnerShape(row.partnerShape || "");

          setFacebook1(row.facebook || "");
          setInstegram1(row.instegram || "");
          setEditedGender(row.gender || "");
          setCellular(row.cellular || "");
          setId1(row.id || "");
          setVipDetails(row.vipDetails || "");
          setIsVip(row.isVip || "");
          setIsActive(row.isActive || "");
          setUserType(row.userType || "");
          setHelperName(row.helperName || "");
          setHelperCellular(row.helperCellular || "");
          setHelperEmail(row.helperEmail || "");
          setHelperConnection(row.helperConnection || "");
          setHelperAllowSee(row.helperAllowSee || 0);
          setM1details(row.m1details || "");
          setM2details(row.m2details || "");
          setM3details(row.m3details || "");
          setM4details(row.m4details || "");
          setM5details(row.m5details || "");

          setImage1aBlobURL("");
          setImage2aBlobURL("");
          setImage3aBlobURL("");
          setImage4aBlobURL("");
          setImage5aBlobURL("");
          setRecordingBlobURL1a("");

          if (row.keyImage1 !== "") {
            const image1Data = await FileManager.getFile(row.keyImage1);
            setImage1aBlobURL(image1Data.blobURL);
          }
          if (row.keyImage2 !== "") {
            const image2Data = await FileManager.getFile(row.keyImage2);
            setImage2aBlobURL(image2Data.blobURL);
          }
          if (row.keyImage3 !== "") {
            const image3Data = await FileManager.getFile(row.keyImage3);
            setImage3aBlobURL(image3Data.blobURL);
          }
          if (row.keyImage4 !== "") {
            const image4Data = await FileManager.getFile(row.keyImage4);
            setImage4aBlobURL(image4Data.blobURL);
          }
          if (row.keyImage5 !== "") {
            const image5Data = await FileManager.getFile(row.keyImage5);
            setImage5aBlobURL(image5Data.blobURL);
          }

          if (row.rec1 !== "") {
            const rec1aBuffer = row.rec1
              .split(",,")
              .map(
                (current) =>
                  new Int8Array(current.split(",").map((current) => +current)),
              );
            const blob1a = new Blob(rec1aBuffer, { type: "audio/mp3" });
            const blob1aURL = URL.createObjectURL(blob1a);
            setRecordingBlobURL1a(blob1aURL);
          }

          setMyRecord1a(row.myRec1 || "");
          setRecord1a(row.rec1 || "");
          setDateRecord1a(row.dateRec1 || "");
          setIsRecord1aPlaying(false);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (otherId !== "" && otherId != null) {
      loadData();
    }
  }, [otherId]);

  return (
    <div className="profile-extra-wrapper">
      <h5 className="profile-extra-section-title">תמונות ועוד</h5>

      <div className="iconsline profile-extra-iconsline">
        <div
          className={
            image1aBlobURL !== "" || image2aBlobURL !== ""
              ? "cameraicon"
              : "cameraicongrey"
          }
          onClick={cameraBtnClick}
        ></div>

        <div
          className={facebook1 !== "" ? "faceicon" : "faceicongrey"}
          onClick={facebook1 !== "" ? facebookBtnClick : () => {}}
        ></div>

        <div
          className={instegram1 !== "" ? "instegramicon" : "instegramicongrey"}
          onClick={instegram1 !== "" ? instegramBtnClick : () => {}}
        ></div>

        <div
          className={
            recordingBlobURL1a !== "" ? "recordicon" : "recordicongrey"
          }
          onClick={recordingBlobURL1a !== "" ? recordBtnClick : () => {}}
        ></div>
      </div>

      <div className={cameraAreaVisible ? "areaAboutMeCard" : "invisible"}>
        {image1aBlobURL !== "" && (
          <img className="image-doubleMatch" src={image1aBlobURL} alt="" />
        )}
        {image2aBlobURL !== "" && (
          <img className="image-doubleMatch" src={image2aBlobURL} alt="" />
        )}
        {image3aBlobURL !== "" && (
          <img className="image-doubleMatch" src={image3aBlobURL} alt="" />
        )}
        {image4aBlobURL !== "" && (
          <img className="image-doubleMatch" src={image4aBlobURL} alt="" />
        )}
        {image5aBlobURL !== "" && (
          <img className="image-doubleMatch" src={image5aBlobURL} alt="" />
        )}
      </div>

      <div className={faceAreaVisible ? "areaAboutMeCard" : "invisible"}>
        הקישור לפייס הוא:{" "}
        <a href={facebook1} target="_blank" rel="noopener noreferrer">
          {facebook1}
        </a>
      </div>

      <div className={instegramAreaVisible ? "areaAboutMeCard" : "invisible"}>
        הקישור לאינסטגרם הוא:{" "}
        <a href={instegram1} target="_blank" rel="noopener noreferrer">
          {instegram1}
        </a>
      </div>

      <div className={recordAreaVisible ? "areaAboutMeCard" : "invisible"}>
        <div className="record-line">
          <ReactPlayer
            playing={isRecord1aPlaying}
            autoPlay={false}
            url={recordingBlobURL1a}
            controls={true}
            progressInterval={100}
            config={{ file: { forceAudio: true } }}
            onEnded={() => setIsRecord1aPlaying(false)}
            width="0px"
            height="0px"
          />
          <div style={{ width: "33.3%" }}>
            <div
              className={
                "playicon-button " +
                (isRecord1aPlaying ? "pause-icon" : "play-icon")
              }
              onClick={() => setIsRecord1aPlaying(!isRecord1aPlaying)}
            ></div>
            <p className="lbl">לשמיעה</p>
          </div>
          {myRecord1a == 1 ? "אני על עצמי" : "מספרים עלי"}
          {record1a + dateRecord1a}
        </div>
      </div>

      <h5 className="vipDescription profile-extra-section-title">
        מה המועמד/ת סימן/ה שמחפש/ת
      </h5>

      <div className="profile-extra-info-box">
        <h5>גילאים פרטנר</h5>
        <div className="messegeMatch">{agepartner}</div>

        <h5>גובה פרטנר</h5>
        <div className="messegeMatch">{tallpartner}</div>

        <h5>עד מרחק</h5>
        <div className="messegeMatch">{distancepartner} ק"מ</div>

        <h5>דת פרטנר</h5>
        <div className="messegeMatch">
          {religouspartner
            ? religouspartner
                .split(",")
                .map((current) =>
                  editedGender == "1"
                    ? getWomanDictionary("pdat" + current)
                    : getManDictionary("pdat" + current),
                )
                .join(", ")
            : ""}
        </div>

        <h5>סטטוס פרטנר</h5>
        <div className="messegeMatch">
          {statuspartner
            ? statuspartner
                .split(",")
                .map((current) =>
                  editedGender == "1"
                    ? getWomanDictionary("psta" + current)
                    : getManDictionary("psta" + current),
                )
                .join(", ")
            : ""}
        </div>

        <h5>השכלה פרטנר</h5>
        <div className="messegeMatch">
          {educationpartner
            ? educationpartner
                .split(",")
                .map((current) =>
                  editedGender == "1"
                    ? getManDictionary("pedu" + current)
                    : getWomanDictionary("pedu" + current),
                )
                .join(", ")
            : ""}
        </div>

        <h5>מבנה פרטנר</h5>
        <div className="messegeMatch">{partnerShape}</div>

        <h5>האם פעיל?</h5>
        <div className="messegeMatch">
          {Number(isActive) === 1 ? "כן" : "לא"}
        </div>

        <h5>האם מנוי?</h5>
        <div className="messegeMatch">{Number(isVip) === 1 ? "כן" : "לא"}</div>
      </div>

      {showManagerOnly && (
        <>
          <h5 className="vipDescription profile-extra-section-title">
            מידע למנהל בלבד
          </h5>

          <div className="profile-extra-info-box">
            <h5> טלפון משתמש|מספר סידורי|פעיל|חסום</h5>
            <div className="messegeMatch">{cellular + "|" + id1}</div>

            <h5>vip, date, route, gift</h5>
            <div className="messegeMatch">{vipDetails}</div>

            <h5>דאבליסט</h5>

            <div className="messegeMatch">
              <b>שם:</b> {helperName}
            </div>

            <div className="messegeMatch">
              <b>טלפון:</b> {helperCellular}
            </div>

            <div className="messegeMatch">
              <b>מייל:</b> {helperEmail}
            </div>

            <div className="messegeMatch">
              <b>קשר:</b> {getFamilyCon(helperConnection)}
            </div>

            <div className="messegeMatch">
              <b>הרשאת צפייה:</b> {helperAllowSee === 1 ? "כן" : "לא"}
            </div>

            <h5>התאמות קודמות</h5>
            <div className="messegeMatch">
              {"row1: " + m1details}
              <br />
              {"row2: " + m2details}
              <br />
              {"row3: " + m3details}
              <br />
              {"row4: " + m4details}
              <br />
              {"row5: " + m5details}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GetOneProfileExtra;
